import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Card, Table } from "react-bootstrap";
import { useLazyGetCompletedQuizByIdQuery } from "../../slices/fun_stuff/quizUsersSlice";
import { useLazyGetQuizByIdQuery } from "../../slices/fun_stuff/quizSlice";
import { useLoadQuizScoreboard } from "../../hooks/useLoadQuizScoreboard";
import RecreateQuiz from "./RecreateQuiz";
import Loader from "../Loader";

const levels = {
    'elementary': 'Elementary',
    'high_school': 'High School',
    'honors': 'Honors',
    'university': 'University',
};

const Scoreboard = () => {
  const { quizScoreboard } = useSelector(state => state.quizAuth);

  const [showQuiz, setShowQuiz] = useState(false);
  const [quiz, setQuiz] = useState(0);

  const [getCompletedQuiz, { isLoading: completedLoading }] = useLazyGetCompletedQuizByIdQuery();
  const [getQuiz, { isLoading: quizLoading }] = useLazyGetQuizByIdQuery();

  const { loadScoreboard } = useLoadQuizScoreboard();
  useEffect(() => {
    const load = async () => {
      await loadScoreboard();
    }
    if (!quizScoreboard?.completed_quizzes?.graded && !quizScoreboard?.completed_quizzes?.fun) {
      load();
    }
  }, [quizScoreboard]);

  const handleRecreateQuiz = async (quiz) => {
    const quizData = await getCompletedQuiz(quiz.quiz_id);
    setQuiz({
      topic: quiz.topic,
      level: quiz.level,
      date_completed: quiz.date_completed,
      questions: quizData.data.questions,
      graded: quizData.data.graded,
    });
    setShowQuiz(true);
  }

  const handleGetQuiz = async (quiz) => {
    const quizData = await getQuiz(quiz.quiz_id);
    setQuiz({
      topic: quiz.topic,
      level: quiz.level,
      date_completed: quiz.date_completed,
      questions: quizData.data.questions,
      graded: false,
    });
    setShowQuiz(true);
  }

  if (!quizScoreboard) return <></>;
  if (completedLoading || quizLoading) return <Loader />;
  return (
    <Card className="scoreboard mt-4 shadow-sm">
      <Card.Header className="card-header-dark">
        <h3>Scoreboard</h3>
      </Card.Header>

      
      {showQuiz && 
      <RecreateQuiz 
        quiz={quiz}
        setShowQuiz={setShowQuiz}
      />}

      <Row>
        <Col xs={12} md={4} className="mx-auto">
          <Card className="m-2 shadow-sm">
            <Card.Header as="h5">Overall Score</Card.Header>
            <Card.Body className="d-flex flex-column align-items-center">
              <Row className="mb-1">
                <Col xs="auto"><strong>Total:</strong></Col>
                <Col>{`${quizScoreboard.total_correct}/${quizScoreboard.total_questions}`}</Col>
              </Row>
              <Row>
                <Col xs="auto"><strong>Score:</strong></Col>
                <Col className="mx-0">{parseFloat(quizScoreboard.percent_score)}%</Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={8} className="mx-auto">
          <Card className="m-2 shadow-sm">
            <Card.Header as="h5">Score by Level</Card.Header>
            <Card.Body>
              <Table striped bordered hover responsive size="sm">
                <thead>
                  <tr>
                    <th>Level</th>
                    <th className="text-center">Score</th>
                    <th className="text-center">Percent Score</th>
                  </tr>
                </thead>
                <tbody>
                  {quizScoreboard?.score_by_level?.map((levelData, idx) => (
                    <tr key={idx}>
                      <td>{levels[levelData.level]}</td>
                      <td className="text-center">{`${levelData.total_correct}/${levelData.total_questions}`}</td>
                      <td className="text-center">{parseFloat(levelData.percent_score)}%</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="m-2 shadow-sm">
        <Card.Header as="h5">Graded Quizzes</Card.Header>
        <Card.Body>
          <Table striped hover bordered responsive size="sm">
            <thead>
              <tr>
                <th className="d-none d-md-table-cell">Date</th>
                <th>Topic</th>
                <th>Level</th>
                <th className="text-center">Score</th>
                <th className="text-center">Percent</th>
              </tr>
            </thead>
            <tbody>
              {quizScoreboard?.completed_quizzes?.graded?.map((quiz, idx) => (
                <tr 
                  key={idx} 
                  onClick={() => handleRecreateQuiz(quiz)} className="scoreboard-table"
                >
                  <td className="d-none d-md-table-cell">{new Date(quiz.date_completed).toLocaleDateString()}</td>
                  <td>{quiz.topic}</td>
                  <td>{levels[quiz.level]}</td>
                  <td className="text-center">{`${quiz.number_correct}/${quiz.number_questions}`}</td>
                  <td className="text-center">{parseFloat(quiz.percent_score)}%</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card> 

      <Card className="m-2 shadow-sm">
        <Card.Header as="h5">Completed For Funsies</Card.Header>
        <Card.Body>
          <Row className="justify-content-center">
            <Col xs={12} lg={9}>
              <Table striped bordered hover responsive size="sm">
                <thead>
                  <tr>
                    <th className="d-none d-md-table-cell">Date</th>
                    <th>Topic</th>
                    <th>Level</th>
                  </tr>
                </thead>
                <tbody>
                  {quizScoreboard?.completed_quizzes?.fun?.map((quiz, idx) => (
                    <tr 
                      key={idx}
                      onClick={() => handleGetQuiz(quiz)} className="scoreboard-table"
                    >
                      <td className="d-none d-md-table-cell">{new Date(quiz.date_completed).toLocaleDateString()}</td>
                      <td>{quiz.topic}</td>
                      <td>{levels[quiz.level]}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card> 
    </Card>
  );
};

export default Scoreboard;
